import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import MembersFlatTable from '../MembersFlatTable';
import TagIcon from 'icons/Tag.icon';
import ResolvePopup from 'components/ResolvePopup';
import InformationcircleIcon from 'icons/Informationcircle.icon';
import { getArrayLength } from 'utils';
import useMembers from '../../../../hooks/useMembers';
import useSellSideActions from '../../hooks/useSellSideActions';
import useMemberDrawers from '../../hooks/useMemberDrawers';
import {
  MEMBERS_TABLE_LIMIT,
  SELL_SIDE_PAGE_PARAM,
} from '../MembersFlatTable/data';

import './SellSide.styles.scss';

type SellSideProps = {
  className?: string;
};

const SellSide: React.FC<SellSideProps> = (props) => {
  const { className } = props;

  const { sellSideMembers } = useMembers();

  const { RenderAddMemberDrawer, actionButton } = useSellSideActions();

  const {
    selectedMemberId,
    onEdit,
    onDeleteMember,
    onAcceptRequest,
    onRejectRequest,
    onEditMemberRole,
    renderDrawers,
  } = useMemberDrawers();

  const { t } = useTranslation();

  const classes = classNames('sell-side', 'white-panel', className);

  return (
    <section className={classes}>
      <div className="members-panel__header">
        <div className="members-panel__title">
          <TagIcon />
          <p className="name">{t('sellSide')}</p>

          <ResolvePopup onHover popupContent={t('sellSideColleaguesPopup')}>
            <InformationcircleIcon />
          </ResolvePopup>

          <p className="count">
            {t('numOfcolleagues', { count: getArrayLength(sellSideMembers) })}
          </p>
        </div>

        <div className="members-panel__actions">{actionButton}</div>
      </div>

      <MembersFlatTable
        members={sellSideMembers}
        pageParam={SELL_SIDE_PAGE_PARAM}
        limit={MEMBERS_TABLE_LIMIT}
        selectedMemberId={selectedMemberId}
        onRowClick={onEdit}
        onEdit={onEdit}
        onDeleteMember={onDeleteMember}
        onAcceptRequest={onAcceptRequest}
        onRejectRequest={onRejectRequest}
        onEditMemberRole={onEditMemberRole}
        renderDrawers={renderDrawers}
      />

      {RenderAddMemberDrawer}
    </section>
  );
};

export default SellSide;
